export default "__VITE_ASSET__6efbec49__"